import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Panel } from "@/components/si/Bits";
import { rDel, rErr, rPost } from "@/lib/radar";

const when = (d) => (d ? new Date(d).toLocaleString([], { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "");

// Dated running notes on a Radar company (§65).
export const CompanyNotes = ({ companyId, notes, setNotes }) => {
  const [t, setT] = useState("");
  const [busy, setBusy] = useState(false);
  const add = async () => {
    if (!t.trim()) return;
    setBusy(true);
    try { const r = await rPost(`/companies/${companyId}/notes`, { text: t.trim() }); setNotes([r?.note || r?.item || { id: `n${Date.now()}`, text: t.trim(), created_at: new Date().toISOString() }, ...notes]); setT(""); toast.success("Note added"); }
    catch (e) { toast.error(e.response?.status === 404 ? "Company notes aren't live on the backend yet (spec §65)." : rErr(e)); } finally { setBusy(false); }
  };
  const del = async (n) => {
    if (!window.confirm("Delete this note?")) return;
    try { await rDel(`/companies/${companyId}/notes/${n.id}`); setNotes(notes.filter((x) => x.id !== n.id)); } catch (e) { toast.error(rErr(e)); }
  };
  return (
    <Panel title={`Notes (${notes.length})`} testid="radar-company-notes">
      <Textarea rows={2} value={t} onChange={(e) => setT(e.target.value)} placeholder="Add a note: call outcome, who to ask for, best time to reach them…" className="text-xs" data-testid="radar-note-input" />
      <Button size="sm" onClick={add} disabled={busy || !t.trim()} className="mt-2 h-7 bg-[#D4AF37] text-black hover:bg-[#F3C649]" data-testid="radar-note-add">{busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Add note</Button>
      <div className="mt-2">{notes.map((n, i) => (
        <div key={n.id || i} className="group border-t border-[#1f1f23] py-2 text-xs" data-testid={`radar-note-${i}`}>
          <p className="whitespace-pre-wrap break-words text-zinc-200">{n.text}</p>
          <p className="mt-0.5 flex items-center gap-2 text-[10px] text-zinc-500">{when(n.created_at)}{n.author_name ? ` · ${n.author_name}` : ""}<button onClick={() => del(n)} className="ml-auto text-zinc-600 hover:text-red-400" data-testid={`radar-note-del-${i}`}><Trash2 className="h-3 w-3" /></button></p>
        </div>))}</div>
    </Panel>
  );
};
